// extracted by mini-css-extract-plugin
module.exports = {"heading_1":"peIlfp","heading_2":"ki9vwf","heading_3":"_4Oac4g","heading_4":"_9dSDYV","heading_5":"wXE3MD","heading_6":"n2zKC8"};